module.exports = __webpack_public_path__ + "static/media/galerija_2023 (17).e69ec09e.png";